import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_block_handle_menu = _resolveComponent("block-handle-menu")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([$data.C.blockRhythm, $data.C.blockFrame, $data.C.blockSeparator])
  }, [
    _createElementVNode("hr", {
      class: _normalizeClass($data.C.separator)
    }, null, 2 /* CLASS */),
    ($props.editable)
      ? (_openBlock(), _createBlock(_component_block_handle_menu, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), null, 16 /* FULL_PROPS */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}